interface ApiErrorResponse {
  response: {
    data: {
      error: {
        message: string;
      } | string;
    };
  };
}



export const formatErrorSavePost = (message: string | null) => {
  const patterns = [
    /HTTP \d+: Bad Request \((.*?)\)/, // Captura lo que está dentro de los paréntesis
    /HTTP \d+: (.*?) \(.*?\)/, // Captura el mensaje antes del primer paréntesis
    /HTTP \d+: (.*)/, // Captura todo el mensaje después del código HTTP
  ];

  for (const regex of patterns) {
    const match = message?.match(regex);
    if (match) {
      const [, userMessage] = match;
      return {
        statusCode: '400',
        shortMessage: userMessage,
        detailedMessage: '',
        userMessage: userMessage,
      };
    }
  }

  return {
    statusCode: 'N/A',
    shortMessage: 'Formato desconocido',
    detailedMessage: '',
    userMessage: message || 'Ocurrió un error desconocido',
  };
};

const customErrors = [
  {
    pattern: /Username (\d+ )?belongs to a different user/, 
    message: 'El post ya está participado con otro usuario o el post no está asociado a tu perfil',
  },
];


const getCustomError = (message: string) => {
  for (const { pattern, message: customMessage } of customErrors) {
    if (pattern.test(message)) {
      return customMessage;
    }
  }
  return message;
};

export const getError = (error: ApiErrorResponse | Error): string => {
  if ('response' in error && error.response?.data?.error) {
    if (typeof error.response.data.error === 'string') {
      return getCustomError(formatErrorSavePost(error.response.data.error)?.userMessage);
    }
    if (typeof error.response.data.error === 'object' && 'message' in error.response.data.error) {
      return getCustomError(formatErrorSavePost(error.response.data.error.message)?.userMessage);
    }
  }
  if (error instanceof Error) {
    return getCustomError(formatErrorSavePost(error.message)?.userMessage);
  }

  return 'Ocurrió un error desconocido';
};
